import $ from 'jquery';

$(document).on('click', '.sponsored-video-feed-template__play', function () {
    const $this = $(this);
    const parent = $this.parent();

    parent.find('.sponsored-video-feed-template__thumbnail').remove();
    parent.find('.sponsored-video-feed-template__play').remove();
    parent.find('.sponsored-video-feed-template__video').show();

    if (parent.find('video').length) {
        parent.find('video')[0].play();
    } else {
        parent
            .find('iframe')
            .attr('src', parent.find('iframe').attr('src') + '&autoplay=1');

        parent.find('iframe').attr('allow', 'autoplay');
    }
});
